namespace $.$$ {

	$mol_style_define( $shm_wordstat_task_catalog, {
		width: '100%',
		minWidth: 0,
		flex: { grow: 1, shrink: 1 },

		List_head: {
			flex: { grow: 1, shrink: 1 },
		},

		Content: {
			flexDirection: 'column',
			minWidth: 0,
			overflow: 'auto',
		},

		Stats: {
			flexWrap: 'wrap',
			gap: $mol_gap.block,
			padding: '8px',
		},

		Table: {
			flexDirection: 'column',
			gap: 0,
			minWidth: '760px',
			width: '100%',
		},

		Rows: {
			flexDirection: 'column',
			gap: 0,
			minWidth: 0,
		},

		Table_head: {
			display: 'grid',
			gridTemplateColumns: 'minmax(150px, 1.2fr) minmax(150px, 1.3fr) 110px 165px 130px',
			gap: '8px',
			padding: { left: '8px', right: '8px' },
			color: $mol_theme.shade,
			font: { size: '12px', weight: 'bold' },
		},

		Task: {
			display: 'grid',
			gridTemplateColumns: 'minmax(150px, 1.2fr) minmax(150px, 1.3fr) 110px 165px 130px',
			alignItems: 'center',
			gap: '8px',
			minWidth: 0,
			width: '100%',
			minHeight: '40px',
			padding: { left: '8px', right: '8px' },
			flex: { grow: 0, shrink: 0 },
			border: {
				top: { width: '1px', style: 'solid', color: $mol_theme.line },
			},
		},

		Task_title: {
			minWidth: 0,
			width: '100%',
			overflowWrap: 'anywhere',
		},

		Task_queries: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Task_daily: {
			justifyContent: 'center',
		},
	} )

}
